export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11647.f3c0eba2.jpg";